var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterV1 = function SvgFilterV1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.333 12h1.334c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666H7.333c-.366 0-.666.3-.666.666s.3.667.666.667M2 4.667c0 .366.3.666.667.666h10.666c.367 0 .667-.3.667-.666S13.7 4 13.333 4H2.667C2.3 4 2 4.3 2 4.667m2.667 4h6.666c.367 0 .667-.3.667-.667s-.3-.667-.667-.667H4.667C4.3 7.333 4 7.633 4 8s.3.667.667.667"
  })));
};
export default SvgFilterV1;